import Navbar from "@/components/home/Navbar";
import HeroSection from "@/components/home/HeroSection";
import AboutSection from "@/components/home/AboutSection";
import PromoVideoSection from "@/components/home/PromoVideoSection";
import PhoneMockupSection from "@/components/home/PhoneMockupSection";
import InvestmentPlanSection from "@/components/home/InvestmentPlanSection";
import WhyChooseSection from "@/components/home/WhyChooseSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import CompanyStatsSection from "@/components/home/CompanyStatsSection";
import WithdrawalTicker from "@/components/home/WithdrawalTicker";
import DepositTicker from "@/components/home/DepositTicker";

import SecuritySection from "@/components/home/SecuritySection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import TrustpilotBadge from "@/components/home/TrustpilotBadge";
import PartnersSection from "@/components/home/PartnersSection";
import RegulatorySection from "@/components/home/RegulatorySection";
import Footer from "@/components/home/Footer";
import VisitorNotification from "@/components/home/VisitorNotification";
import heroBg from "@/assets/hero-bg.png";
import bitcoinTree from "@/assets/bitcoin-tree.png";

const Index = () => {
  return (
    <div className="min-h-screen bg-background relative">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0 overflow-hidden">
        <img
          src={heroBg}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-15 animate-[slowZoom_30s_ease-in-out_infinite_alternate]"
        />
        <div className="absolute inset-0 bg-background/80" />
      </div>
      <div className="relative z-10">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <PromoVideoSection />
        <PhoneMockupSection />
        <InvestmentPlanSection />
        <WhyChooseSection />
        <HowItWorksSection />
        <CompanyStatsSection />
        <DepositTicker />
        <div className="flex flex-col items-center py-12 px-4 text-center gap-6">
          <img src={bitcoinTree} alt="Bitcoin tree illustration" className="max-w-md w-full h-auto rounded-2xl shadow-lg glow-gold" />
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mt-4">
            Grow your BTC & BNB with <span className="text-primary">Prime Profit</span> — the new generation digital wealth.
          </h2>
          <p className="text-lg md:text-xl font-semibold tracking-widest text-muted-foreground uppercase">
            Learn &nbsp;|&nbsp; Earn &nbsp;|&nbsp; Inspire
          </p>
        </div>
        <WithdrawalTicker />
        <SecuritySection />
        <TrustpilotBadge />
        <TestimonialsSection />
        <PartnersSection />
        <RegulatorySection />
      </main>
      <Footer />
      <VisitorNotification />
      </div>
    </div>
  );
};

export default Index;
